import { c, PolymorphicComponentPropsWithRef, PolymorphicRef } from 'lib/component-utils'
import { ElementType, forwardRef } from 'react'

type Props<T extends ElementType> = PolymorphicComponentPropsWithRef<T>

const Container = <T extends ElementType = 'section'>(
  { as, className, children, ...props }: Props<T>,
  ref?: PolymorphicRef<T>
) => {
  const Component = as ?? 'section'

  return (
    <Component className={c`py-20 sm:py-32 ${className}`} ref={ref} {...props}>
      <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl">{children}</div>
    </Component>
  )
}

export default forwardRef(Container) as typeof Container
